<div class="justify-content" [ngClass]="{'no-flex single-file-upload' : preview}">
    <div class="flex-start">
        <div class="flex-elipsis">
            <span> <!--*ngIf="ctrl.showFileName()"-->
                <label for="file-name" class="no-margin"><i class="fa fa-paperclip grey-text semi-large-text bold-text" attr.aria-hidden="true"></i> {{'citation.field.file' | translate}}:&nbsp;</label>
            </span>
            <div class="elipsis-text" id="file-name" [tooltip]="file.amazonDisplayFileName">
                <span>{{file.amazonDisplayFileName}}</span>
                <span class="semibold-text" *ngIf="!file.fileItem.isError">({{file.fileItem.file.size}} bytes)</span> <!--*ngIf="!file.errors"-->
                <!-- <div class="input-message warning-inverse" *ngFor="error in file.errors" *ngIf="file.errors?.length" role="alert" aria-live="assertive">
					{{error}}
				</div> -->
                <span *ngIf="file.fileItem.isError">({{'request.dialog.status.FAILED' | translate}})</span>
            </div>
        </div>
    </div>
    <div class="flex-end">
        <!-- <button id="remove-file" class="btn btn-link btn-icon-only medium-text" *ngIf="allowDelete" (click)="file.fileItem.remove()" [tooltip]="'citation.edit.removeFile' | translate" tooltip-placement="left" tooltip-trigger="'focus mouseenter'" attr.aria-label="{{'citation.edit.removeFile' | translate}}">
            <i class="fa fa-trash" attr.aria-hidden="true"></i>
        </button> -->
        <!-- no-privileges="COURSE_RESERVES" -->
        <span *ngIf="notAllowDeleteReason" [tooltip]="'notAllowDeleteReason' | translate" attr.aria-label="{{'notAllowDeleteReason' | translate}}" tooltip-placement="auto">
            <i class="fa fa-question-circle" attr.aria-hidden="true"></i>
        </span>
    </div>
</div>